import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { RESULT_PATH_IV24, VALUATION_FUNNEL_PATH_IV24 } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const Component = () => import('@/pages/PropertyValuation');
const ResultComponent = () =>
  import('@/components/property-valuation-page/ResultPage/ResultPage.vue');

const valuationFunnelRoutes: LocalizedRoutes = {
  de: { path: VALUATION_FUNNEL_PATH_IV24['de'] },
  en: { path: VALUATION_FUNNEL_PATH_IV24['en'] },
  fr: { path: VALUATION_FUNNEL_PATH_IV24['fr'] },
  it: { path: VALUATION_FUNNEL_PATH_IV24['it'] },
};

const resultRoutes: LocalizedRoutes = {
  de: { path: RESULT_PATH_IV24['de'] },
  en: { path: RESULT_PATH_IV24['en'] },
  fr: { path: RESULT_PATH_IV24['fr'] },
  it: { path: RESULT_PATH_IV24['it'] },
};

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(valuationFunnelRoutes, Component, Pages.IV24Funnel);

const resultLocalizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(resultRoutes, ResultComponent, Pages.IV24Result);

export {
  localizedRouteConfig as getIV24IFrameValuationFunnelRoute,
  resultLocalizedRouteConfig as getIV24ResultRoute,
};
